import { MODAL_NEW_GENERATE_PROJECT } from '@components/App/Modal/constants'
import { openModal } from '@storeOld/reducers/ui'
import type React from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'

import { OptionalMain } from './OptionalMain'

export const AiSitemap: React.FC = () => {
  const dispatch = useDispatch()
  const [params] = useSearchParams()

  useEffect(() => {
    dispatch(
      // @ts-expect-error
      openModal(MODAL_NEW_GENERATE_PROJECT, {
        defaultTheme: params.get('theme'),
      })
    )
  }, [])

  return <OptionalMain />
}
